import axios from "axios";

const sendEmail = async (reqData) => {
    const result = await axios.post("https://rwbose7loc.execute-api.us-east-1.amazonaws.com/datum-rest-api/datumart-sendemail", reqData);
    return result.data;
}

export const APIService = {
    sendEmail: sendEmail
}